import EnhancedBadgeManager from './EnhancedBadgeManager';

const BadgeManager = () => {
  return <EnhancedBadgeManager />;
};

export default BadgeManager;